export function getEventX(e) {
  return e.pageX | (e.changedTouches ? e.changedTouches[ 0 ].pageX : 0);
}
